import script from "./ReviewYourPurchases.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewYourPurchases.vue?vue&type=script&setup=true&lang=js"

import "./ReviewYourPurchases.vue?vue&type=style&index=0&id=5124d584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5124d584"]])

export default __exports__